export class StockAddressUpdateJsEnv {
  code: string;
  message: string;
  address: string;

  constructor(
    code: string,
    message: string,
    address: string
    ) {
    this.code = code;
    this.message = message;
    this.address = address;
  }
}
